module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-card recent-events-card"
  }, [_c('div', {
    staticClass: "recent-events-header"
  }, [_c('div', {
    staticClass: "recent-events-title-row"
  }, [_c('div', {
    staticClass: "recent-events-icon-wrap",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    staticClass: "recent-events-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "9",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 7v5l3 2",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "recent-events-heading"
  }, [_vm._v("Recent Events")])]), _vm._v(" "), _c('div', {
    staticClass: "recent-events-segment",
    attrs: {
      "role": "group",
      "aria-label": "Time range"
    }
  }, [_c('button', {
    staticClass: "recent-events-segment-btn",
    class: {
      active: _vm.selectedPeriod === '7d'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setPeriod('7d')
      }
    }
  }, [_vm._v("7d")]), _vm._v(" "), _c('button', {
    staticClass: "recent-events-segment-btn",
    class: {
      active: _vm.selectedPeriod === '30d'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setPeriod('30d')
      }
    }
  }, [_vm._v("30d")]), _vm._v(" "), _c('button', {
    staticClass: "recent-events-segment-btn",
    class: {
      active: _vm.selectedPeriod === '90d'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setPeriod('90d')
      }
    }
  }, [_vm._v("90d")])])]), _vm._v(" "), _c('div', {
    staticClass: "recent-events-list"
  }, [_vm._l((_vm.filteredEvents), function(event, index) {
    return _c('div', {
      key: index,
      staticClass: "recent-events-row"
    }, [_c('div', {
      staticClass: "recent-events-description"
    }, [_vm._v(_vm._s(event.title))]), _vm._v(" "), _c('div', {
      staticClass: "recent-events-meta"
    }, [_vm._v(_vm._s(event.timeAgo))])])
  }), _vm._v(" "), (!_vm.filteredEvents || _vm.filteredEvents.length === 0) ? _c('p', {
    staticClass: "recent-events-empty"
  }, [_vm._v("No events in this period.")]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d71688a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product-details/RecentEvents.vue
// module id = 813
// module chunks = 2